import { Link } from '@Components/RoutesUtils';
import { useConfig } from '@Src/providers/ConfigProvider';
import { useDesignSchema } from '@Src/providers/DesignSchemaProvider';
import { getMobileAppIcons } from '@Src/utility/mobileAppsUtils';

const MobileAppBadges = (): JSX.Element => {
  const { language } = useConfig();
  const { AppStoreBadge, GooglePlayBadge } = getMobileAppIcons(language);
  const { mobileApps, appStoreUrl, playStoreUrl } = useDesignSchema();

  return (
    <>
      {mobileApps?.hasApple && (mobileApps?.appStoreUrl || appStoreUrl) && (
        <Link
          to={appStoreUrl || mobileApps?.appStoreUrl || ''}
          data-fd="app-store-badge"
        >
          <AppStoreBadge />
        </Link>
      )}
      {mobileApps?.hasAndroid && (mobileApps?.playStoreUrl || playStoreUrl) && (
        <Link
          to={playStoreUrl || mobileApps?.playStoreUrl || ''}
          data-fd="play-store-badge"
        >
          <GooglePlayBadge />
        </Link>
      )}
    </>
  );
};

export default MobileAppBadges;
